interface Props { size?: number; showText?: boolean; }

export default function Logo({ size = 40, showText = true }: Props) {
  return (
    <div className="flex items-center gap-3">
      <img
        src="https://storage.helloreaddy.io/project_files/ad59199e-f97b-4804-9fcb-2a33acc61184/c2656eff-2fa8-4189-b192-08c712bc3eb6_compressed_Untitled-design1.webp"
        alt="FormaCode Technologies Logo"
        className="rounded-lg"
        style={{ width: size, height: size, objectFit: 'contain' }}
      />
      {showText && (
        <div className="leading-tight">
          <div className="font-display font-bold text-white text-lg tracking-tight">
            Form<span className="text-neon-400">A</span>Code
          </div>
          <div className="text-[10px] tracking-[0.3em] text-neon-300/80 font-mono">TECHNOLOGIES</div>
        </div>
      )}
    </div>
  );
}